import React, { forwardRef, useEffect, useRef,useImperativeHandle } from "react";
import * as d3 from 'd3';
import useEditorStore from "@/store/useEditorStore";
import { D3Node } from "./D3Node";


/*
Node definition
The node definition contains all of the information about the node needed by the editor. It is an object with the following properties:

category: (string) the palette category the node appears in
defaults: (object) the editable properties for the node.
credentials: (object) the credential properties for the node.
inputs: (number) how many inputs the node has, either 0 or 1.
outputs: (number) how many outputs the node has. Can be 0 or more.
color: (string) the background colour to use.
paletteLabel: (string|function) the label to use in the palette.
label: (string|function) the label to use in the workspace.
labelStyle: (string|function) the style to apply to the label.
inputLabels: (string|function) optional label to add on hover to the input port of a node.
outputLabels: (string|function) optional labels to add on hover to the output ports of a node.
icon: (string) the icon to use.
align: (string) the alignment of the icon and label.
button: (object) adds a button to the edge of the node.
oneditprepare: (function) called when the edit dialog is being built. See custom edit behaviour.
oneditsave: (function) called when the edit dialog is okayed. See custom edit behaviour.
oneditcancel: (function) called when the edit dialog is canceled. See custom edit behaviour.
oneditdelete: (function) called when the delete button in a configuration node’s edit dialog is pressed. See custom edit behaviour.
oneditresize: (function) called when the edit dialog is resized. See custom edit behaviour.
onpaletteadd: (function) called when the node type is added to the palette.
onpaletteremove: (function) called when the node type is removed from the palette.
*/


const NodeLayer = forwardRef(({flow, onDbClick, width, size},ref) => {
    const node_map = useEditorStore.use.node_map();

    useEffect(() => {
        if (ref.current) {
            const nodeLayer = d3.select(ref.current);
        }
    }, [width, size]);

    return (<g ref={ref}>
      {Object.entries(node_map)
          .filter(([, o]) => o?.drawable !== false)
          .map(([key, obj], index) => {
            if(obj.type != "tab" && obj.type != "bizwechat-configurator") {
              return (<D3Node key={key} onDbClick={onDbClick} payload={obj} />);
            }
})}
    </g>);
});


export default NodeLayer;
